const initial = {
  point_id: null,
  status: 'hidden',
  callback: null
};

export default {
  namespaced: true,
  state: {...initial},
  actions: {
    clear({commit}) {
      commit('CLOSE_FORM');
    },
    edit({commit}, {
      point_id,
      callback
    }) {
      commit('SHOW_FORM', {
        status: 'edit',
        point_id: point_id,
        callback
      });
    }
  },
  mutations: {
    CLOSE_FORM(state) {
      state.status = initial.status;
      state.point_id = initial.point_id;
      state.callback = initial.callback;
    },
    SHOW_FORM(state, {
      status,
      point_id,
      callback
    }) {
      state.status = status;
      state.point_id = point_id;
      state.callback = callback || initial.callback;
    }
  }
};
